<template>
  <span class="custom-copy"
    >{{ txt }}
    <span @click="handleCopy($event, txt)" class="btn">
      <span class="color526bec">复制</span></span
    ></span
  >
</template>
<script>
import handleClipboard from "@/utils/copy";
export default {
  name: "Custom-Copy",
  props: {
    txt: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {
    handleCopy($event, txt) {
      handleClipboard($event, txt);
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-copy {
  .color526bec {
    font-size: 0.12rem;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
